import React, { useEffect } from "react";

import { useKnowledgeBases } from "@/shared/api/knowledge";
import KnowledgeBasePage from "./KnowledgeBasePage";
import KnowledgeListPage from "./KnowledgeListPage";
import type { NavigationOptions } from "@/shared/types";

/* `/knowledge` is the home, `/knowledge/<kbId>` one base and `/knowledge/<kbId>/<nodeId>` a
   folder or file open in it. A second segment that is not a base of this org (an old
   `#/knowledge/<agentId>` link) goes back to the home, in place of the entry. The base page is
   not keyed by its base: its rail of every base stays put while another base opens beside it. */
export default function KnowledgeView({ kbId, nodeId = null, onOpen }: {
  kbId: string | null;
  nodeId?: string | null;
  onOpen: (kbId: string | null, nodeId?: string | null, how?: NavigationOptions) => void;
}) {
  const { data } = useKnowledgeBases();
  const known = !!kbId && !!data?.some((b) => b.id === kbId);

  useEffect(() => {
    if (kbId && data && !known) onOpen(null, null, { replace: true });
  }, [kbId, data, known, onOpen]);

  if (known) return <KnowledgeBasePage kbId={kbId} nodeId={nodeId} onOpen={onOpen} />;
  return <KnowledgeListPage onOpen={onOpen} />;
}
